import { type NotificationItem, type NotificationList } from "@herskin/contracts";
import { IconButton, StatusBadge } from "@herskin/ui";
import {
  IconLayoutSidebarRight as PanelRight,
  IconLogout as LogOut,
  IconSparkles as Sparkles,
} from "@tabler/icons-react";
import { NotificationCenter, type BrowserNotificationState } from "./NotificationCenter";
import { ProductSubtitle } from "./ProductBrand";
import type { WorkspaceId } from "./WorkspaceDock";

const WORKSPACE_TITLES: Record<WorkspaceId, string> = {
  overview: "概览",
  chat: "会话",
  memory: "记忆",
  cron: "任务",
  files: "文件",
  more: "更多",
};

interface AppTopbarProps {
  activeWorkspace: WorkspaceId;
  browserOnline: boolean;
  hermesOnline: boolean;
  notificationsOpen: boolean;
  notifications: NotificationList | null;
  browserNotificationState: BrowserNotificationState;
  onToggleNotifications: () => void;
  onOpenNotification: (item: NotificationItem) => void;
  onEnableBrowserNotifications: () => void;
  onToggleInspector: () => void;
  onLogout: () => void;
}

/** 全局品牌、连接状态和通知入口；一级页面本身无需重复维护顶栏结构。 */
export function AppTopbar({
  activeWorkspace,
  browserOnline,
  hermesOnline,
  notificationsOpen,
  notifications,
  browserNotificationState,
  onToggleNotifications,
  onOpenNotification,
  onEnableBrowserNotifications,
  onToggleInspector,
  onLogout,
}: AppTopbarProps) {
  return (
    <header className="topbar">
      <div className="topbar-left">
        <div className="mini-mark">
          <Sparkles size={16} />
        </div>
        <strong className="topbar-page-title">HerSkin - {WORKSPACE_TITLES[activeWorkspace]}</strong>
        <ProductSubtitle className="topbar-subtitle" />
      </div>
      <div className="topbar-actions">
        <StatusBadge tone={browserOnline && hermesOnline ? "success" : "warning"} showDot>
          {!browserOnline
            ? "HerSkin 连接恢复中"
            : hermesOnline
              ? "Hermes 已连接"
              : "Hermes 连接恢复中"}
        </StatusBadge>
        <NotificationCenter
          open={notificationsOpen}
          list={notifications}
          browserState={browserNotificationState}
          onToggle={onToggleNotifications}
          onOpen={onOpenNotification}
          onEnableBrowser={onEnableBrowserNotifications}
        />
        {activeWorkspace === "chat" ? (
          <IconButton aria-label="切换运行检查器" onClick={onToggleInspector}>
            <PanelRight />
          </IconButton>
        ) : null}
        <IconButton aria-label="退出登录" onClick={onLogout}>
          <LogOut />
        </IconButton>
      </div>
    </header>
  );
}
